const cleanString = (value) => {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  return text;
};

const normalizeValueList = (value) => {
  if (Array.isArray(value)) {
    return Array.from(new Set(value.map((item) => cleanString(item)).filter(Boolean)));
  }
  const single = cleanString(value);
  return single ? [single] : [];
};

const isObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const isLocationObject = (value) =>
  isObject(value) &&
  ("original_location" in value ||
    "modified_location" in value ||
    "original_country" in value ||
    "modified_country" in value);

export function extractLocationCountry(entity) {
  const rawLocation = entity?.location;

  if (isLocationObject(rawLocation)) {
    const locationValues = normalizeValueList(rawLocation?.modified_location ?? "");
    const countryValues = normalizeValueList(rawLocation?.modified_country ?? "");

    const location = locationValues[0] || "";
    const country = countryValues[0] || "";

    return { location, country };
  }

  const location = normalizeValueList(rawLocation)[0] || "";
  const country = normalizeValueList(entity?.country)[0] || "";
  return { location, country };
}

export function getLocationValues(entity) {
  const rawLocation = entity?.location;
  if (isLocationObject(rawLocation)) {
    return normalizeValueList(rawLocation?.modified_location ?? "");
  }
  return normalizeValueList(rawLocation);
}

export function getCountryValues(entity) {
  const rawLocation = entity?.location;
  if (isLocationObject(rawLocation)) {
    return normalizeValueList(rawLocation?.modified_country ?? "");
  }
  return normalizeValueList(entity?.country);
}

export function formatLocation(entity) {
  return getLocationValues(entity).join(", ");
}

export function formatCountry(entity) {
  return getCountryValues(entity).join(", ");
}

export function formatLocationCountry(entity) {
  const location = formatLocation(entity);
  const country = formatCountry(entity);
  // "Zurich, Switzerland" already names the country: don't append it again.
  if (location && country && location.toLowerCase().endsWith(country.toLowerCase())) return location;
  if (location && country) return `${location}, ${country}`;
  return location || country || "";
}
